export default () => ({
    root: {
        margin: "15px 0",
    }
});